<div class="hidden xl:block tab-content" id="profileContent">
  <!-- Columna del formulario -->
  <div class="2xl:col-span-3">
    <form class="space-y-4" [formGroup]="passwordChangeForm">
      <h4 class="text-xl font-medium text_white">Establecer Nueva Contraseña
      </h4>

      <!-- Fila: Campos de entrada para establecer contraseña -->
      <div class="grid grid-cols-1 gap-4">
        <!-- Primer campo de "Establecer contraseña" -->
        <div>
          <div class="relative w-full lg:w-1/3">
            <!-- Ícono de candado a la izquierda -->
            <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
                <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                <path d="M15 16h.01" />
                <path d="M12.01 16h.01" />
                <path d="M9.02 16h.01" />
              </svg>
            </div>
            <!-- Input para establecer contraseña -->
            <input id="password1" placeholder="Contraseña Actual" formControlName="currentPassword"
              [ngClass]="passwordChangeForm.get('currentPassword')?.dirty && passwordChangeForm.get('currentPassword')?.errors ? 'classwarning': 'noclasswarning'"
              [type]="showCurrentPassword ? 'text' : 'password'" autocomplete="off"
              class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
            <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
            <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
              (click)="toggleCurrentPasswordVisibility()">
              <!-- 👁️ functionality-->
              <i [ngClass]="showCurrentPassword ? 'pi-eye' : 'pi-eye-slash'"
                class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
            </button>

          </div>
          <small style="color: #FC6161 ;" *ngIf="passwordChangeForm.get('currentPassword')?.invalid &&
            passwordChangeForm.get('currentPassword')?.value?.length > 0" class="p-invalid w-full px-1">
            {{passwordChangeForm.get('currentPassword')?.hasError('incorrect') ? 'Contraseña Incorrecta': 'Utiliza al menos 8 caracteres'}}
            
          </small>
          <small style="color: #FC6161 ;" *ngIf="
            passwordChangeForm.get('currentPassword')?.dirty &&
            passwordChangeForm.get('currentPassword')?.hasError('required')
          " class="p-invalid w-full px-1">Contraseña requerida</small>
        </div>
        <!-- Primer campo de "Establecer contraseña" -->
        <div>
          <div class="relative w-full lg:w-1/3">
            <!-- Ícono de candado a la izquierda -->
            <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
                <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                <path d="M15 16h.01" />
                <path d="M12.01 16h.01" />
                <path d="M9.02 16h.01" />
              </svg>
            </div>
            <!-- Input para establecer contraseña -->
            <input type="password" id="password2" placeholder="Nueva Contraseña" formControlName="newPassword"
              [ngClass]="passwordChangeForm.get('newPassword')?.dirty && passwordChangeForm.get('newPassword')?.errors ? 'classwarning': 'noclasswarning'"
              [type]="showNewPassword ? 'text' : 'password'" autocomplete="off"
              class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
            <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
            <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
              (click)="toggleNewPasswordVisibility()">
              <!-- 👁️ functionality-->
              <i [ngClass]="showNewPassword ? 'pi-eye' : 'pi-eye-slash'"
                class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
            </button>
          </div>
          <small style="color: #FC6161 ;" *ngIf="passwordChangeForm.get('newPassword')?.invalid &&
            passwordChangeForm.get('newPassword')?.value?.length > 0" class="p-invalid w-full px-1">
            {{passwordChangeForm.get('newPassword')?.errors?.['passwordStrength']}}
          </small>
        </div>
        <!-- Segundo campo de "Confirmar contraseña" -->
        <div>
          <div class="relative w-full lg:w-1/3">
            <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
                <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                <path d="M15 16h.01" />
                <path d="M12.01 16h.01" />
                <path d="M9.02 16h.01" />
              </svg>
            </div>
            <input type="password" id="password3" placeholder="Confirmar Nueva Contraseña"
              formControlName="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="off"
              [ngClass]="passwordChangeForm.get('confirmPassword')?.dirty && passwordChangeForm.get('confirmPassword')?.errors ? 'classwarning': 'noclasswarning'"
              class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
            <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
              (click)="toggleConfirmPasswordVisibility()">
              <!-- 👁️ functionality-->
              <i [ngClass]="showConfirmPassword ? 'pi-eye' : 'pi-eye-slash'"
                class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
            </button>
          </div>
          <small style="color: #FC6161 ;"
            *ngIf="passwordChangeForm.get('confirmPassword')?.invalid &&
            passwordChangeForm.get('confirmPassword')?.value?.length > 0 && passwordChangeForm.get('confirmPassword')?.errors?.['notMatching']"
            class="p-invalid w-full px-1">
            Contraseña no es igual
          </small>
        </div>
      </div>
      <!-- Cuarta fila: Botón de guardar -->
      <div class="w-full lg:w-1/3 mt-4">
        <button type="button" (click)="validatePassword()" [disabled]="passwordChangeForm.invalid"
          class="w-full my-2 block py-2 font-normal text-center text_white group button_color_customize hover:button_color_customize hover:text_black font-medium rounded-lg">
          <div class="inline-flex items-center">
            Cambiar contraseña
          </div>
        </button>
      </div>
    </form>
  </div>
</div>

<div class="accordion-content px-4 py-3 pt-5 text_gray card_color block xl:hidden">
  <!-- Contenido del acordeón -->

  <form class="space-y-4" [formGroup]="passwordChangeForm">
    <div class="grid grid-cols-1 gap-4">
      <!-- Primer campo de "Establecer contraseña" -->
      <div>
        <div class="relative w-full">
          <!-- Ícono de candado a la izquierda -->
          <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <!-- Input para establecer contraseña -->
          <input [type]="showCurrentPassword ? 'text' : 'password'"
            [ngClass]="passwordChangeForm.get('currentPassword')?.dirty && passwordChangeForm.get('currentPassword')?.errors ? 'classwarning': 'noclasswarning'"
            id="password1" placeholder="Contraseña Actual" formControlName="currentPassword"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
          <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
          <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="toggleCurrentPasswordVisibility()">
            <!-- 👁️ functionality-->
            <i [ngClass]="showCurrentPassword ? 'pi-eye' : 'pi-eye-slash'"
              class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
          </button>

        </div>
        <small style="color: #FC6161 ;" *ngIf="passwordChangeForm.get('currentPassword')?.invalid &&
            passwordChangeForm.get('currentPassword')?.value?.length > 0" class="p-invalid w-full px-1">
          {{ passwordChangeForm.get('currentPassword')?.hasError('incorrect') ? 'Contraseña Incorrecta': 'Utiliza al menos 8 caracteres'}}
        </small>
        <small style="color: #FC6161 ;" *ngIf="
            passwordChangeForm.get('currentPassword')?.dirty &&
            passwordChangeForm.get('currentPassword')?.hasError('required')
          " class="p-invalid w-full px-1">Contraseña requerida</small>
      </div>


      <!-- Primer campo de "Establecer contraseña" -->
      <div>
        <div class="relative w-full">
          <!-- Ícono de candado a la izquierda -->
          <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <!-- Input para establecer contraseña -->
          <input type="password" id="password2" placeholder="Nueva Contraseña" formControlName="newPassword"
            [ngClass]="passwordChangeForm.get('newPassword')?.dirty && passwordChangeForm.get('newPassword')?.errors ? 'classwarning': 'noclasswarning'"
            [type]="showNewPassword ? 'text' : 'password'" autocomplete="off"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
          <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
          <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="toggleNewPasswordVisibility()">
            <!-- 👁️ functionality-->
            <i [ngClass]="showNewPassword ? 'pi-eye' : 'pi-eye-slash'"
              class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
          </button>
        </div>
        <small style="color: #FC6161 ;" *ngIf="passwordChangeForm.get('newPassword')?.invalid &&
          passwordChangeForm.get('newPassword')?.value?.length > 0" class="p-invalid w-full px-1">
          {{passwordChangeForm.get('newPassword')?.errors?.['passwordStrength']}}
        </small>
      </div>
      

      <!-- Segundo campo de "Confirmar contraseña" -->
      <div>
        <div class="relative w-full">
          <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <input type="password" id="password3" placeholder="Confirmar Nueva Contraseña"
            formControlName="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="off"
            [ngClass]="passwordChangeForm.get('confirmPassword')?.dirty && passwordChangeForm.get('confirmPassword')?.errors ? 'classwarning': 'noclasswarning'"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
          <button type="button" class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="toggleConfirmPasswordVisibility()">
            <!-- 👁️ functionality-->
            <i [ngClass]="showConfirmPassword ? 'pi-eye' : 'pi-eye-slash'"
              class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"></i>
          </button>
        </div>
        <small style="color: #FC6161 ;"
            *ngIf="passwordChangeForm.get('confirmPassword')?.invalid &&
            passwordChangeForm.get('confirmPassword')?.value?.length > 0 && passwordChangeForm.get('confirmPassword')?.errors?.['notMatching']"
            class="p-invalid w-full px-1">
            Contraseña no es igual
          </small>
      </div>
      
    </div>
  </form>
  <!-- Cuarta fila: Botón de guardar -->
  <div class="text-left mt-4">
    <button type="button"
      (click)="validatePassword()" [disabled]="passwordChangeForm.invalid"
      class="open-forgot-your-password-04 w-full px-6 py-2 template_color_customize text_white font-semibold rounded-md">
      Cambiar contraseña
    </button>
  </div>
</div>

<div id="modalConfirmPassword" class="modal fixed inset-0 bg-black bg-opacity-70 items-center justify-center z-50"
  [ngClass]="showConfirmDialog ? 'flex' : 'hidden'" (click)="closeOnBackdrop($event)">
  <!-- Contenedor interno -->
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8"
    (click)="$event.stopPropagation()">

    <!-- Botón de cierre (X) -->
    <button type="button" class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="closeConfirmDialog()">
      &times;
    </button>

    <!-- Contenido del modal -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none">
      <div class="mb-4">
        <img [routerLink]="['/']" [src]="logo" alt="Logo Cliente"
          class="pl-0 w-1/2 m-auto h-full border-round-sm fadein animation-duration-300 cursor-pointer" />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-2 text-left">Confirmar Cambio</h2>
      <p class="text-md font-light mb-2 sm:mb-3">¿Confirmas el cambio de tu contraseña?</p>

      <!-- Botones -->
      <div class="flex flex-row gap-2">
        <button type="button" (click)="closeConfirmDialog()"
          [disabled]="updatingPassword"
          class="w-full py-3 mt-4 text-base font-medium text_white focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-lg">
          Cancelar
        </button>

        <button type="submit" (click)="confirmChangePassword()"
          [disabled]="updatingPassword"
          class="w-full py-3 mt-4 text-base font-medium template_color_customize rounded-lg hover:scale-105 transition-transform hover:opacity-70 ">
          Continuar
        </button>
      </div>
    </div>
  </div>
</div>